import React from 'react'

import Slide from './Slide'

import ModePreviewAnimation from '../../../../../animations/components/ModePreviewAnimation';

export default class ModePreview extends Slide {
    constructor(options) {
        super(options);
    }

    getComponent(playthrough) {
        return ( 
            <ModePreviewAnimation 
                flags={this.flags}
                dynamicImages={this.dynamicImages}
                staticImages={this.staticImages}
                dynamicAudio={this.dynamicAudio}
                staticAudio={this.staticAudio}
            />
        )
    }
}